<p-dialog
  [header]="translationKeys.downloadDialogComponent.html.dialogTitle | translate"
  [(visible)]="showDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  styleClass="download-dialog"
  (onHide)="cancelEvent.emit()"
>
  <i class="icon-content-query"></i>
  <div class="download-content">
    <span class="title">{{ translationKeys.downloadDialogComponent.html.selectData | translate }}</span>
    <span class="performance-info">
      {{ translationKeys.downloadDialogComponent.html.performanceInfo | translate }}
    </span>
    <avano-radio-checkbox-group [label]="translationKeys.downloadDialogComponent.html.downloadData | translate">
      <avano-radiobutton
        name="downloadType"
        [value]="DownloadType.CurrentPage"
        [(ngModel)]="downloadConfig.downloadType">
        {{ translationKeys.downloadDialogComponent.html.currentPage | translate }}
      </avano-radiobutton>
      <avano-radiobutton
        name="downloadType"
        [value]="DownloadType.AllResults"
        [(ngModel)]="downloadConfig.downloadType">
        {{ translationKeys.downloadDialogComponent.html.allResults | translate }}
      </avano-radiobutton>
    </avano-radio-checkbox-group>
  </div>
  <ng-template pTemplate="footer">
    <button
      type="button"
      avanoButton
      [label]="translationKeys.commonTranslationKey.btn.close | translate"
      icon="icon-content-cancel"
      (click)="cancelEvent.emit()"
    ></button>
    <button
      type="button"
      avanoButton
      [callToAction]="true"
      [label]="translationKeys.downloadDialogComponent.html.download | translate"
      icon="icon-content-download"
      (click)="onDownload()"
    ></button>
  </ng-template>
</p-dialog>
